<div class="bug-report-dialog">
  <div class="header-row">
    <h2 mat-dialog-title>
      <mat-icon aria-hidden="true">bug_report</mat-icon>
      Report a Bug
    </h2>
    <button
      mat-icon-button
      type="button"
      aria-label="Close bug report dialog"
      [disabled]="isSubmitting"
      (click)="onCancel()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Bug type</mat-label>
        <mat-select formControlName="bugType">
          <mat-option [value]="null" disabled>Select a category…</mat-option>
          @for (option of bugTypeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (form.controls.bugType.hasError('required') && form.controls.bugType.touched) {
          <mat-error>Please select a bug category.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          formControlName="description"
          rows="6"
          maxlength="1000"
          placeholder="What happened? What did you expect?"
          aria-describedby="bug-description-counter"></textarea>
        <mat-hint
          id="bug-description-counter"
          align="end"
          aria-live="polite"
          [class.counter-warning]="descriptionLength >= 900">
          {{ descriptionLength }}/1000
        </mat-hint>
        @if (form.controls.description.hasError('required') && form.controls.description.touched) {
          <mat-error>Description is required.</mat-error>
        }
        @if (form.controls.description.hasError('minlength') && form.controls.description.touched) {
          <mat-error>Description must be at least 10 characters.</mat-error>
        }
      </mat-form-field>

      <mat-checkbox formControlName="contactMe">I'm happy to be contacted about this report</mat-checkbox>
      <p class="data-disclosure">
        We capture page URL (without query or fragment), browser, screen size, and timestamp. We do not capture session
        IDs or console errors.
      </p>

      @if (submitError) {
        <div class="submit-error" role="alert" aria-live="assertive">
          {{ submitError }}
        </div>
      }

      <mat-dialog-actions align="end">
        <button mat-stroked-button type="button" [disabled]="isSubmitting" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || isSubmitting">
          @if (isSubmitting) {
            <mat-spinner diameter="18"></mat-spinner>
            <span>Submitting…</span>
          } @else {
            <span>Submit report</span>
          }
        </button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</div>
